const doc = [({"da":({"js":({"admin":({"users":({"passwords":({"new":({"forgot_your_password":"Glemt adgangskode?"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;